

import "./styles.scss";

import { useRef } from 'react';
import { IconLogout, IconMoon, IconSun, IconDownload, IconHelp, IconBrandAndroid, IconBrandApple } from "@tabler/icons-react";

import { Button } from "@fragments";
import Popper from "@fragments/Popper";

import Header from './header'
import UserSelect from './userSelect'
import Search from './search'
import Communities from './communities'
import AdminSection from './adminSection'
import Wallet from '../Header/wallet'
import CreateButton from '../Header/actions/CreateButton'
import Notifications from '@components/Screen/Header/Notifications'
import ChatFloatingButton from '../ChatPanel/FloatingButton'
import { useSidebar } from './SidebarContext'
import { useScreen as useScreenLayout } from '../ScreenContext'
import { useScreen } from '@hooks/useScreen'

import config from '@config'

export default function Sidebar() {
    const { collapsed, isMobile } = useSidebar()
    const { sidebarRef } = useScreenLayout()
    const { resolvedAppearance, setAppearance } = useScreen()

    const downloadBtnRef = useRef()
    const downloadPopperRef = useRef()

    function handleDownloadClick() {
        downloadPopperRef.current?.open(
            [
                {
                    id: 'ios',
                    label: 'Baixar para iOS',
                    icon: <IconBrandApple size={16} />,
                    onClick: () => window.open('https://apps.apple.com/br/app/ginastee/id6448853593'),
                },
                {
                    id: 'android',
                    label: 'Baixar para Android',
                    icon: <IconBrandAndroid size={16} />,
                    onClick: () => window.open('https://play.google.com/store/apps/details?id=com.ginastee'),
                },
            ],
            'bottom-end',
            downloadBtnRef.current
        )
    }

    const className = [
        'cs-sidebar',
        collapsed ? 'cs-sidebar--collapsed' : '',
        isMobile ? 'cs-sidebar--mobile' : '',
    ].filter(Boolean).join(' ')

    return (
        <div ref={sidebarRef} className={className}>

            <Header />
            <Search />
            <Communities />

            {isMobile && !collapsed && (
                <div className="cs-sidebar-mobile-actions">
                    <Wallet />

                    <div className="cs-sidebar-mobile-actions__row">
                        <Notifications />
                        <Button
                            color="overlay"
                            variant="rounded"
                            icon={resolvedAppearance === 'dark' ? <IconMoon /> : <IconSun />}
                            onClick={() => setAppearance(resolvedAppearance === 'dark' ? 'light' : 'dark')}
                            tooltip="Mudar tema"
                        />
                        <Popper controlRef={downloadPopperRef}>
                            <Button
                                ref={downloadBtnRef}
                                color="overlay"
                                variant="rounded"
                                icon={<IconDownload />}
                                onClick={handleDownloadClick}
                                tooltip="Baixar o app"
                            />
                        </Popper>
                        <Button
                            color="overlay"
                            variant="rounded"
                            icon={<IconHelp />}
                            onClick={() => window.open(config.help)}
                            tooltip="Ajuda"
                        />
                    </div>

                    <CreateButton fullWidth />
                    <ChatFloatingButton inline />
                    <Button
                        onClick={() => window.logout()}
                        variant="rounded"
                        color="overlay"
                        endIcon={<IconLogout />}
                        fullWidth
                    >
                        Sair
                    </Button>
                </div>
            )}

            <div className="cs-sidebar-footer mt-5">
                <AdminSection />
                <UserSelect />
            </div>
        </div>
    )
}
